import '../lib/readingtime.js'
import '../lib/joincapture.js'

$(() => {
    //set cookie for cached pages
    var token = $('.js-set-region-redirect');
    if (token.length) {
        $.post(
            token.data('callback'),
            function(data) {
                // to Debug also uncomment in LandingRegionRedirectExtension
                //console.log(data);
            }
        );
    }
    // MatchHeight
    var mHeigths = ['.js-mh-news-card, .js-mh-hp-brand-message-title'];
    $.each(mHeigths, function(i, selector) {
        $(selector).matchHeight({
            property: 'height'
        });
    });
    $(function() {
        if (typeof(Storage) !== "undefined" && typeof(localStorage) != 'undefined' && $('.js-employer-section').length > 0) {
            localStorage.setItem('employerURL', $('.js-employer-section').data('url'));
            localStorage.setItem('lastSession', new Date());
        }
    });
    //Capaign Tiles
    $('.js-reading-target').each(function() {
        const _this = $(this);
        console.log({_this})
        _this.readingTime({
            remotePath: _this.data('link'),
            readingTimeTarget: _this.find('.time-to-read > .ttr-target'),
            remoteTarget: '.typography',
            lessThanAMinuteString: '1 min',
            wordsPerMinute: 200
        });
    });
});
